<template>
  <div class="inner-card-box bg-body">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 banner-one-img text-center ms-2 ms-sm-0">
          <img src="../../../assets/modules/landing-pages/images/home-1/banner-top.webp" alt="llllll" class="img-fluid" />
        </div>
        <div class="col-lg-5 inner-box">
          <p class="mb-2 text-uppercase text-primary sub-title">Look fit, feel fit</p>
          <h1 class="text-secondary heading-title text-capitalize">The Joy Of<br /><span class="text-primary">Right Health</span></h1>
          <p class="title-text">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
          <div class="d-flex align-items-center store-btn">
            <router-link to="#" exact active-class="" exact-active-class="" class="btn btn-primary">Download Free</router-link>
            <router-link to="#" exact active-class="" exact-active-class="" class="btn btn-secondary ms-4">Download Pro</router-link>
          </div>
          <div class="star-box mt-4">
            <div class="d-flex mb-2 align-items-center">
              <div class="border-end pe-2">
                <div class="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5773)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5773">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5772)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5772">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5778)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5778">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5779)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5779">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M9.65623 2.03398C9.80257 1.58357 10.4398 1.58358 10.5861 2.03398L12.1443 6.82956C12.2097 7.03099 12.3974 7.16737 12.6092 7.16737H17.6516C18.1252 7.16737 18.3221 7.77338 17.939 8.05174L13.8596 11.0156C13.6883 11.1401 13.6166 11.3607 13.682 11.5622L15.2402 16.3577C15.3865 16.8081 14.871 17.1827 14.4879 16.9043L10.4085 13.9405C10.2372 13.816 10.0052 13.816 9.83382 13.9405L5.75445 16.9043C5.37131 17.1827 4.85581 16.8081 5.00215 16.3577L6.56033 11.5622C6.62578 11.3607 6.55408 11.1401 6.38274 11.0156L2.30337 8.05174C1.92024 7.77338 2.11714 7.16737 2.59072 7.16737H7.6331C7.84489 7.16737 8.0326 7.03099 8.09805 6.82956L9.65623 2.03398Z" fill="#D9D9D9"></path>
                    <mask id="mask0_1182_914" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="2" y="1" width="17" height="16">
                      <path d="M9.65623 2.03398C9.80257 1.58357 10.4398 1.58358 10.5861 2.03398L12.1443 6.82956C12.2097 7.03099 12.3974 7.16737 12.6092 7.16737H17.6516C18.1252 7.16737 18.3221 7.77338 17.939 8.05174L13.8596 11.0156C13.6883 11.1401 13.6166 11.3607 13.682 11.5622L15.2402 16.3577C15.3865 16.8081 14.871 17.1827 14.4879 16.9043L10.4085 13.9405C10.2372 13.816 10.0052 13.816 9.83382 13.9405L5.75445 16.9043C5.37131 17.1827 4.85581 16.8081 5.00215 16.3577L6.56033 11.5622C6.62578 11.3607 6.55408 11.1401 6.38274 11.0156L2.30337 8.05174C1.92024 7.77338 2.11714 7.16737 2.59072 7.16737H7.6331C7.84489 7.16737 8.0326 7.03099 8.09805 6.82956L9.65623 2.03398Z" fill="#F2B827"></path>
                    </mask>
                    <g mask="url(#mask0_1182_914)">
                      <rect x="-1" y="0.603027" width="13" height="19" fill="#F2B827"></rect>
                    </g>
                  </svg>
                </div>
              </div>

              <img src="@/assets/modules/landing-pages/images/home-1/13.webp" alt="" class="img-fluid ps-2 star-icon" />
            </div>
            <h6 class="mb-0 mt-1 text-black"><span>500k+</span> Downloads</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-secondary features-card">
    <div class="container">
      <div class="row mx-2 mx-sm-0">
        <div class="col-lg-6"></div>
        <div class="col-lg-6 top-feature">
          <div class="text-right">
            <p class="mb-2 text-uppercase sub-title text-white">Why HopeUI rocks</p>
            <h2 class="text-white notch-feature-txt heading-title text-capitalize heading-title">Top Notch Features</h2>
            <p class="title-text mb-0">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
          </div>
        </div>
      </div>
      <div class="row row-cols-sm-2 row-cols-lg-4">
        <div class="col">
          <div class="card services-box rounded-1">
            <div class="card-body p-0">
              <h5 class="mb-3">
                400+ UI<br />
                Components
              </h5>
              <p class="mb-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              <svg width="12" class="text-primary" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.45109 0.343108L5.46396 1.36387L10.0063 1.42104L0.0568434 11.3704L0.787737 12.1013L10.7371 2.15194L10.7943 6.6942L11.8151 6.70706L11.736 0.422159L5.45109 0.343108Z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card services-box rounded-1">
            <div class="card-body p-0">
              <h5 class="mb-3">
                Refreshing<br />
                Design
              </h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              <svg width="12" class="text-primary" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.45109 0.343108L5.46396 1.36387L10.0063 1.42104L0.0568434 11.3704L0.787737 12.1013L10.7371 2.15194L10.7943 6.6942L11.8151 6.70706L11.736 0.422159L5.45109 0.343108Z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card services-box rounded-1">
            <div class="card-body p-0">
              <h5 class="mb-3">
                Universal UI<br />
                Toolkit
              </h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              <svg width="12" class="text-primary" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.45109 0.343108L5.46396 1.36387L10.0063 1.42104L0.0568434 11.3704L0.787737 12.1013L10.7371 2.15194L10.7943 6.6942L11.8151 6.70706L11.736 0.422159L5.45109 0.343108Z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="card services-box rounded-1">
            <div class="card-body p-0">
              <h5 class="mb-3">
                Fully<br />
                Responsive
              </h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              <svg width="12" class="text-primary" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.45109 0.343108L5.46396 1.36387L10.0063 1.42104L0.0568434 11.3704L0.787737 12.1013L10.7371 2.15194L10.7943 6.6942L11.8151 6.70706L11.736 0.422159L5.45109 0.343108Z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-padding">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <img src="../../../assets/modules/landing-pages/images/home-1/aboutus.webp" alt="" class="img-fluid" />
        </div>
        <div class="col-md-6">
          <p class="mb-2 text-primary text-uppercase sub-title">about us</p>
          <h2 class="text-secondary text-capitalize heading-title">
            What they say <br />
            <span class="text-primary">About Us</span>
          </h2>
          <p class="mb-4">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
          <div class="d-flex align-items-center mb-lg-4 mb-3 about-icon-box">
            <div class="p-2 border border-secondary rounded-1 d-flex text-secondary align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M5.5625 9.00008L7.6875 11.1251L11.9375 6.87508M15.8333 9.00008C15.8333 12.9121 12.662 16.0834 8.75 16.0834C4.83798 16.0834 1.66666 12.9121 1.66666 9.00008C1.66666 5.08806 4.83798 1.91675 8.75 1.91675C12.662 1.91675 15.8333 5.08806 15.8333 9.00008Z" stroke="#001F4C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span class="mb-0 ms-1">400+ UI Components</span>
            </div>
            <div class="p-2 border border-secondary rounded-1 d-flex text-secondary align-items-center ms-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M5.5625 9.00008L7.6875 11.1251L11.9375 6.87508M15.8333 9.00008C15.8333 12.9121 12.662 16.0834 8.75 16.0834C4.83798 16.0834 1.66666 12.9121 1.66666 9.00008C1.66666 5.08806 4.83798 1.91675 8.75 1.91675C12.662 1.91675 15.8333 5.08806 15.8333 9.00008Z" stroke="#001F4C" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span class="mb-0 ms-1">92+ CSS Designs</span>
            </div>
          </div>
          <router-link to="javascript" class="btn btn-primary mt-3">Get Started</router-link>
        </div>
      </div>
    </div>
  </div>
  <div class="section-padding bg-body">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <p class="mb-2 text-primary text-uppercase sub-title">Download now</p>
          <h2 class="text-secondary heading-title text-capitalize">
            Fast, easy, and <br />
            <span class="text-primary">Affordable</span>
          </h2>
          <p class="title-text">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
          <div class="d-flex align-items-center store-btn flex-wrap pt-2">
            <img src="../../../assets/modules/landing-pages/images/home-1/playstore.webp" alt="" class="img-fluid" />
            <img src="../../../assets/modules/landing-pages/images/home-1/appstore.webp" alt="" class="img-fluid ms-3" />
          </div>
          <div class="star-box mt-4">
            <div class="d-flex mb-2 align-items-center">
              <div class="border-end pe-2">
                <div class="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5773)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5773">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5772)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5772">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5778)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5778">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_1150_5779)">
                      <path d="M7.63067 1.28789C7.76731 0.959376 8.23272 0.959376 8.36936 1.28789L10.0222 5.26187C10.0798 5.40037 10.2101 5.495 10.3596 5.50698L14.6498 5.85093C15.0045 5.87936 15.1483 6.32197 14.8781 6.55343L11.6094 9.35344C11.4954 9.45104 11.4457 9.60416 11.4805 9.75L12.4791 13.9366C12.5617 14.2826 12.1852 14.5562 11.8815 14.3707L8.20848 12.1273C8.08048 12.0491 7.91951 12.0491 7.7915 12.1273L4.11845 14.3707C3.81481 14.5562 3.43831 14.2826 3.52087 13.9366L4.51951 9.75C4.55431 9.60416 4.50456 9.45104 4.39065 9.35344L1.12193 6.55343C0.851714 6.32197 0.995529 5.87936 1.35019 5.85093L5.64043 5.50698C5.78995 5.495 5.92019 5.40037 5.9778 5.26187L7.63067 1.28789Z" fill="#FDB022"></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_1150_5779">
                        <rect width="16" height="16" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  <svg class="ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M9.65623 2.03398C9.80257 1.58357 10.4398 1.58358 10.5861 2.03398L12.1443 6.82956C12.2097 7.03099 12.3974 7.16737 12.6092 7.16737H17.6516C18.1252 7.16737 18.3221 7.77338 17.939 8.05174L13.8596 11.0156C13.6883 11.1401 13.6166 11.3607 13.682 11.5622L15.2402 16.3577C15.3865 16.8081 14.871 17.1827 14.4879 16.9043L10.4085 13.9405C10.2372 13.816 10.0052 13.816 9.83382 13.9405L5.75445 16.9043C5.37131 17.1827 4.85581 16.8081 5.00215 16.3577L6.56033 11.5622C6.62578 11.3607 6.55408 11.1401 6.38274 11.0156L2.30337 8.05174C1.92024 7.77338 2.11714 7.16737 2.59072 7.16737H7.6331C7.84489 7.16737 8.0326 7.03099 8.09805 6.82956L9.65623 2.03398Z" fill="#D9D9D9"></path>
                    <mask id="mask0_1182_914" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="2" y="1" width="17" height="16">
                      <path d="M9.65623 2.03398C9.80257 1.58357 10.4398 1.58358 10.5861 2.03398L12.1443 6.82956C12.2097 7.03099 12.3974 7.16737 12.6092 7.16737H17.6516C18.1252 7.16737 18.3221 7.77338 17.939 8.05174L13.8596 11.0156C13.6883 11.1401 13.6166 11.3607 13.682 11.5622L15.2402 16.3577C15.3865 16.8081 14.871 17.1827 14.4879 16.9043L10.4085 13.9405C10.2372 13.816 10.0052 13.816 9.83382 13.9405L5.75445 16.9043C5.37131 17.1827 4.85581 16.8081 5.00215 16.3577L6.56033 11.5622C6.62578 11.3607 6.55408 11.1401 6.38274 11.0156L2.30337 8.05174C1.92024 7.77338 2.11714 7.16737 2.59072 7.16737H7.6331C7.84489 7.16737 8.0326 7.03099 8.09805 6.82956L9.65623 2.03398Z" fill="#F2B827"></path>
                    </mask>
                    <g mask="url(#mask0_1182_914)">
                      <rect x="-1" y="0.603027" width="13" height="19" fill="#F2B827"></rect>
                    </g>
                  </svg>
                </div>
              </div>

              <img src="@/assets/modules/landing-pages/images/home-1/13.webp" alt="" class="img-fluid ps-2 star-icon" />
            </div>
            <h6 class="mb-0 mt-1 text-black"><span>500k+</span> Downloads</h6>
          </div>
        </div>
        <div class="col-lg-7 mt-5 mt-lg-0">
          <img src="../../../assets/modules/landing-pages/images/home-1/dwn-1.webp" alt="" class="img-fluid d-block mx-auto" />
        </div>
      </div>
    </div>
  </div>
  <div class="section-card-padding">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-4">
          <div class="mb-2 text-primary text-uppercase sub-title">Pricing</div>
          <h2 class="text-secondary heading-title text-capitalize heading-title">
            Our
            <span class="text-primary"
              >Price<br />
              Plans</span
            >
          </h2>
          <p class="title-text">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
          <router-link to="#" exact active-class="" exact-active-class="" class="btn btn-primary">View demo</router-link>
        </div>
        <div class="col-lg-8 mt-4 mt-lg-0">
          <div class="row iq-star-inserted row-cols-1 row-cols-md-2 row-cols-lg-2 text-center">
            <div class="col">
              <div class="card shadow-lg">
                <div class="card-body my-2">
                  <h5 class="my-0 fw-normal mb-4">Pro</h5>
                  <div class="d-flex justify-content-center align-items-baseline mb-4">
                    <h4 class="card-title pricing-card-title mb-0 text-primary">$15</h4>
                    <h6 class="mb-0">/ month</h6>
                  </div>
                  <p class="text-black mb-0">Billed Yearly</p>
                  <p class="text-black">$169.99 Billed Monthly</p>
                  <ul class="list-unstyled my-3 p-0">
                    <li class="mb-4">20 users included</li>
                    <li class="mb-4">10GB of storage</li>
                    <li class="mb-4">Priority Email support</li>
                    <li class="mb-4">Help center access</li>
                    <li class="mb-4">Help center access</li>
                    <li><p>Help center access</p></li>
                  </ul>
                  <button type="button" class="btn btn-primary w-100">Get Started</button>
                </div>
              </div>
            </div>
            <div class="col iq-star-inserted-3">
              <div class="card my-5">
                <div class="card-body page-bg">
                  <h5 class="my-0 fw-normal mb-4">Premium</h5>
                  <div class="d-flex justify-content-center align-items-baseline mb-4">
                    <h4 class="card-title pricing-card-title mb-0 text-primary">$49</h4>
                    <h6 class="mb-0">/ month</h6>
                  </div>
                  <p class="text-black mb-0">Billed Yearly</p>
                  <p class="text-black">$169.9 Billed Monthly</p>
                  <ul class="list-unstyled my-3 p-0">
                    <li class="mb-3">30 users included</li>
                    <li class="mb-3">15 GB of storage</li>
                    <li class="mb-3">Call and email support</li>
                    <li class="mb-3 text-decoration-line-through">Help center access</li>
                    <li class="mb-3">Help center access</li>
                    <li>Help center access</li>
                  </ul>
                  <button type="button" class="btn custom-btn btn-white w-100 shadow">Get Started</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="inner-box overflow-hidden">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="mb-2 text-uppercase text-primary sub-title">App Screenshots</div>
          <h2 class="text-secondary text-capitalize heading-title">Seamless User Experience, Assured!</h2>
          <p class="heading-main-title">It is specially designed for any kind of mobile app, software, sass, startup,<br />marketing, one page and other online businesses.</p>
        </div>
      </div>
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-2 col-md-6">
          <img src="@/assets/modules/landing-pages/images/home-1/01.webp" alt="10" class="img-fluid d-block mx-auto" />
        </div>
        <div class="col-lg-2 col-md-6">
          <img src="@/assets/modules/landing-pages/images/home-1/02.webp" alt="11" class="img-fluid d-block mx-auto" />
        </div>
        <div class="col-lg-3 col-md-12">
          <img src="@/assets/modules/landing-pages/images/home-1/03.webp" alt="12" class="img-fluid d-block mx-auto" />
        </div>
        <div class="col-lg-2 col-md-6">
          <img src="@/assets/modules/landing-pages/images/home-1/15.webp" alt="13" class="img-fluid d-block mx-auto" />
        </div>
        <div class="col-lg-2 col-md-6">
          <img src="@/assets/modules/landing-pages/images/home-1/16.webp" alt="14" class="img-fluid d-block mx-auto" />
        </div>
      </div>
    </div>
  </div>
  <div class="section-card-padding bg-body">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-12 text-center">
          <div class="mb-2 text-uppercase text-primary sub-title">team</div>
          <h2 class="text-secondary heading-title text-capitalize">We are a team of dedicated <br /><span class="text-primary">professionals </span></h2>
          <p class="heading-main-title">
            It is a long established fact that a reader will be distracted by the readable content<br />
            of a page when looking at its layout.
          </p>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4">
        <div class="col">
          <div class="card team-image">
            <TeamWidget :teamImage="require('@/assets/modules/landing-pages/images/home-1/team1.webp')" teamTitle="Darlene Robertson" teamText="Founder" />
          </div>
        </div>
        <div class="col">
          <div class="card team-image">
            <TeamWidget :teamImage="require('@/assets/modules/landing-pages/images/home-1/team2.webp')" teamTitle="Floyd Miles" teamText="UI designer" />
          </div>
        </div>
        <div class="col">
          <div class="card team-image">
            <TeamWidget :teamImage="require('@/assets/modules/landing-pages/images/home-1/team-3.webp')" teamTitle="Arlene McCoy" teamText="Researcher" />
          </div>
        </div>
        <div class="col">
          <div class="card team-image">
            <TeamWidget :teamImage="require('@/assets/modules/landing-pages/images/home-1/team-4.webp')" teamTitle="Darlene Robertson" teamText="Founder" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-card-padding">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-12 text-center">
          <p class="mb-2 text-uppercase text-primary sub-title">Blog</p>
          <h2 class="text-secondary text-capitalize heading-main-title">All the <span class="text-primary">Support you Need</span></h2>
        </div>
        <div class="overflow-hidden slider-circle-btn app-slider swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events" id="app-slider">
          <swiper
            class="p-0 m-0 list-inline"
            :navigation="{
              nextEl: '#blog-tranding-next',
              prevEl: '#blog-tranding-prev'
            }"
            :modules="modules"
            :space-between="32"
            :breakpoints="{ 270: { slidesPerView: 1 }, 550: { slidesPerView: 2 }, 991: { slidesPerView: 3 }, 1400: { slidesPerView: 3 }, 1500: { slidesPerView: 3 }, 1920: { slidesPerView: 3 }, 2040: { slidesPerView: 3 }, 2440: { slidesPerView: 3 } }">
            <swiper-slide class="swiper-slide card-slide card overflow-hidden">
              <BlogWidget
                :blogImage="require('@/assets/modules/landing-pages/images/home-1/04.webp')"
                id="01"
                blogTitle="The
                        Cheapest Destinations Of All Time, A List Of Beauty And Budget."
                blogText="August 16,2023" />
            </swiper-slide>
            <swiper-slide class="swiper-slide card-slide card overflow-hidden">
              <BlogWidget :blogImage="require('@/assets/modules/landing-pages/images/home-1/05.webp')" id="02" blogTitle="Technology that unwinds your potential." blogText="August 17,2023" />
            </swiper-slide>
            <swiper-slide class="swiper-slide card-slide card overflow-hidden">
              <BlogWidget :blogImage="require('@/assets/modules/landing-pages/images/home-1/06.webp')" id="03" blogTitle="Generating the best online environment." blogText="August 18,2023" />
            </swiper-slide>
            <swiper-slide class="swiper-slide card-slide card overflow-hidden">
              <BlogWidget
                :blogImage="require('@/assets/modules/landing-pages/images/home-1/04.webp')"
                id="04"
                blogTitle="The
                        Cheapest Destinations Of All Time, A List Of Beauty And Budget."
                blogText="August 19,2023" />
            </swiper-slide>
            <swiper-slide class="swiper-slide card-slide card overflow-hidden">
              <BlogWidget :blogImage="require('@/assets/modules/landing-pages/images/home-1/05.webp')" id="05" blogTitle="Technology that unwinds your potential." blogText="August 20,2023" />
            </swiper-slide>
            <swiper-slide class="swiper-slide card-slide card overflow-hidden">
              <BlogWidget :blogImage="require('@/assets/modules/landing-pages/images/home-1/04.webp')" id="06" blogTitle="Generating the best online environment." blogText="August 21,2023" />
            </swiper-slide>
          </swiper>
          <div class="swiper-button swiper-button-next" id="blog-tranding-next"></div>
          <div class="swiper-button swiper-button-prev" id="blog-tranding-prev"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="section-padding bg-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="mb-2 text-uppercase text-primary sub-title">Build better & Faster</div>
          <h2 class="text-secondary heading-main-title text-capitalize">
            Make something<br />
            <span class="text-primary">great </span> out of nothing
          </h2>
        </div>
      </div>
      <div class="row align-items-center text-center row-cols-2 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 mt-4">
        <div class="col mb-lg-0 mb-4">
          <h2 class="mb-3 counter text-primary">
            <Vue3autocounter ref="counter" :duration="3" :startAmount="0" :endAmount="3" />
          </h2>
          <h6>Best Designer Award</h6>
        </div>
        <div class="col mb-lg-0 mb-4">
          <h2 class="mb-3 counter text-primary">
            <Vue3autocounter ref="counter" :duration="3" :startAmount="0" :endAmount="50" suffix="+" />
          </h2>
          <h6>Loyal Clients</h6>
        </div>
        <div class="col">
          <h2 class="mb-3 counter text-primary">
            <Vue3autocounter ref="counter" :duration="3" :startAmount="0" :endAmount="158" suffix="+" />
          </h2>
          <h6>Nominee Awards</h6>
        </div>
        <div class="col">
          <h2 class="mb-3 counter text-primary">
            <Vue3autocounter ref="counter" :duration="3" :startAmount="0" :endAmount="92" suffix="+" />
          </h2>
          <h6>CSS Designs</h6>
        </div>
      </div>
    </div>
  </div>
  <div class="section-padding bg-secondary position-relative">
    <div class="container client-list">
      <ul class="p-0 m-0 d-flex align-items-center gap-3 client-mrquee list-unstyled">
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/12.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/07.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/08.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/09.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/10.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/11.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/12.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/07.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/08.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/09.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/10.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/11.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/12.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/07.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/08.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/09.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/10.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/11.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/12.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/07.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/08.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/09.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/10.webp')" />
        </li>
        <li class="client-list-img">
          <ClientWidget :clientImage="require('@/assets/modules/landing-pages/images/home-1/11.webp')" />
        </li>
      </ul>
    </div>
  </div>
  <div class="section-padding">
    <div class="container">
      <div class="row align-items-center text-center">
        <div class="col-lg-12">
          <p class="mb-2 text-uppercase text-primary sub-title">Testimony</p>
          <h2 class="text-secondary customer-txt heading-main-title text-capitalize">
            What our
            <span class="text-primary">Customer’s</span> are saying
          </h2>
        </div>
        <div class="overflow-hidden slider-circle-btn" id="testimonial-slider">
          <swiper
            class="p-0 m-0 list-inline mySwiper"
            :navigation="{
              nextEl: '#blog-tranding-next',
              prevEl: '#blog-tranding-prev'
            }"
            :modules="modules"
            :breakpoints="{ 270: { slidesPerView: 1 }, 550: { slidesPerView: 1 }, 991: { slidesPerView: 1 }, 1400: { slidesPerView: 1 }, 1500: { slidesPerView: 1 }, 1920: { slidesPerView: 1 }, 2040: { slidesPerView: 1 }, 2440: { slidesPerView: 1 } }">
            <swiper-slide class="swiper-slide">
              <TestimonialWidgetVue :testimonialImage="require('@/assets/modules/landing-pages/images/home-1/14.webp')" testText="Torquatos nec eu, detr periculis ex, nihil expetendis in mei. Mei an pericula euripidis.hinc partem ei est. Eos ei nisl graecis, vix aperiri consequat an. Eius lorem tincidunt vix at, vel pertinax sensibus id, error epicurei mea. Mea facilisis urbanitas.Torquatos nec eu, detr periculis ex, nihil expetendis in mei." testOwner="Elsa Schmidt" testSubtitle="Spa" alt="test-01" />
            </swiper-slide>
            <swiper-slide class="swiper-slide">
              <TestimonialWidgetVue :testimonialImage="require('@/assets/modules/landing-pages/images/home-1/17.webp')" testText="Torquatos nec eu, detr periculis ex, nihil expetendis in mei. Mei an pericula euripidis.hinc partem ei est. Eos ei nisl graecis, vix aperiri consequat an. Eius lorem tincidunt vix at, vel pertinax sensibus id, error epicurei mea. Mea facilisis urbanitas.Torquatos nec eu, detr periculis ex, nihil expetendis in mei." testOwner="Leslie Alexander" testSubtitle="Hair stylist" alt="test-02" />
            </swiper-slide>
            <swiper-slide class="swiper-slide">
              <TestimonialWidgetVue :testimonialImage="require('@/assets/modules/landing-pages/images/home-1/18.webp')" testText="Torquatos nec eu, detr periculis ex, nihil expetendis in mei. Mei an pericula euripidis.hinc partem ei est. Eos ei nisl graecis, vix aperiri consequat an. Eius lorem tincidunt vix at, vel pertinax sensibus id, error epicurei mea. Mea facilisis urbanitas.Torquatos nec eu, detr periculis ex, nihil expetendis in mei." testOwner="Robert Fox" testSubtitle="Trainer" alt="test-03" />
            </swiper-slide>
            <swiper-slide class="swiper-slide">
              <TestimonialWidgetVue :testimonialImage="require('@/assets/modules/landing-pages/images/home-1/17.webp')" testText="Torquatos nec eu, detr periculis ex, nihil expetendis in mei. Mei an pericula euripidis.hinc partem ei est. Eos ei nisl graecis, vix aperiri consequat an. Eius lorem tincidunt vix at, vel pertinax sensibus id, error epicurei mea. Mea facilisis urbanitas.Torquatos nec eu, detr periculis ex, nihil expetendis in mei." testOwner="Leslie Alexander" testSubtitle="Hair stylist" alt="test-04" />
            </swiper-slide>
            <swiper-slide class="swiper-slide">
              <TestimonialWidgetVue :testimonialImage="require('@/assets/modules/landing-pages/images/home-1/14.webp')" testText="Torquatos nec eu, detr periculis ex, nihil expetendis in mei. Mei an pericula euripidis.hinc partem ei est. Eos ei nisl graecis, vix aperiri consequat an. Eius lorem tincidunt vix at, vel pertinax sensibus id, error epicurei mea. Mea facilisis urbanitas.Torquatos nec eu, detr periculis ex, nihil expetendis in mei." testOwner="Robert Fox" testSubtitle="Trainer" alt="test-05" />
            </swiper-slide>
          </swiper>
          <div class="swiper-button swiper-button-next" id="blog-tranding-next"></div>
          <div class="swiper-button swiper-button-prev" id="blog-tranding-prev"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// swiper
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination, Navigation } from 'swiper'

// components
import TeamWidget from '../../../components/widgets/TeamWidget.vue'
import BlogWidget from '../../../components/widgets/BlogWidget.vue'
// import CounterWidget from '@/components/widgets/CounterWidget.vue'
import ClientWidget from '@/components/widgets/ClientWidget.vue'
import TestimonialWidgetVue from '@/components/widgets/TestimonialWidget.vue'
import Vue3autocounter from '@/assets/vendor/vue3-autocounter'

export default {
  components: {
    TeamWidget,
    BlogWidget,
    // CounterWidget,
    Vue3autocounter,
    ClientWidget,
    TestimonialWidgetVue,
    Swiper,
    SwiperSlide
  },
  setup() {
    return {
      modules: [Navigation, Pagination]
    }
  }
}
</script>
